// 发起通知
export default [
    {
        path: '/initiateNotification',
        component: resolve => require(['@/pages/notice'], resolve),
        name: 'initiateNotification',
        meta: {
            title: '发送通知'
        }
    },
    {
        path: '/receiveNotification',
        component: resolve => require(['@/pages/notice/receiveNotice'], resolve),
        name: 'receiveNotification',
        meta: {
            title: '收到通知'
        }
    },
    {
        path: '/notice/noticeList',
        component: resolve => require(['@/pages/navigationMenu/noticeList'], resolve),
        name: 'noticeList',
        meta: {
            title: '通知列表'
        }
    },
    {
        path: '/createGroupChat',
        component: resolve => require(['@/pages/notice/createGroupChat'], resolve),
        name: 'createGroupChat',
        meta: {
            title: '创建群聊'
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/modules/notice.js